import React, { useCallback, useEffect } from "react";
import { TunnusBroadcastMessageVariant } from "@yleisradio/tunnus-sdk";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import { tunnusExists } from "../../hooks/useLoginData/useLoginData";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";

import {
  NonPlayableButton,
  NonPlayableVideoOverlay,
  NonPlayableVideoText
} from "./NonPlayableStyles";

export const Identification = ({
  refreshComponent
}: {
  refreshComponent: () => Promise<unknown>;
}) => {
  const { useStoreState } = usePlayerStore();
  const setLoginData = useStoreState.setLoginData();
  const { language } = useEmbedParametersContext();

  const onClick = useCallback(() => {
    window.ylePlayer.tunnus?.logIn?.();
  }, []);

  const tunnusListener = useCallback(
    (msg: TunnusBroadcastMessageVariant) => {
      if (
        msg.type === "tunnus-user-info-available" ||
        msg.type === "tunnus-logged-in"
      ) {
        setLoginData({
          loggedIn: true,
          residenceInFinland: msg.user?.residenceInFinland || false,
          userId: msg.user.userId
        });
        void refreshComponent();
      }
    },
    [refreshComponent, setLoginData]
  );

  useEffect(() => {
    if (!tunnusExists()) return;
    window.ylePlayer.tunnus.addMessageListener(tunnusListener);
    return () => {
      window.ylePlayer.tunnus.removeMessageListener(tunnusListener);
    };
  }, [tunnusListener]);

  return (
    <NonPlayableVideoOverlay>
      <NonPlayableVideoText>
        {i18n("katso_eun_alueella", { language })}
      </NonPlayableVideoText>
      <NonPlayableButton
        onClick={onClick}
        text={i18n("aloita", { language })}
      />
    </NonPlayableVideoOverlay>
  );
};
